module.exports = __webpack_public_path__ + "img/jurgen_heberle.077d301f.png";